import { useCallback } from 'react';
import { useStore } from '@ui/hooks/useStore';

const useCookiesPolicy = () => {
    const { app, lang } = useStore();

    const handleApprove = useCallback(() => {
        app.setCookiesApproved();
    }, []);
    const handlers = {
        handleApprove,
    };

    return {
        app,
        lang,
        handlers,
    };
};

export default useCookiesPolicy;
